import template from './referrerConnect.html';
import ReferrerConnectCtrl from './referrerConnectCtrl';

export default {
  template,
  bindings: {
    familyId: '=',
    email: '<',
  },
  controller: ReferrerConnectCtrl,
  controllerAs: 'vm',
};
